<template>
  <v-app :style="{ backgroundColor: siteSettings.background_color }">
    <!-- App Bar -->

    <v-app-bar
      v-if="isMobile"
      :style="{ backgroundColor: siteSettings.header_color }"
      app
      elevation="12"
    >
    
    <v-img
        src="@/assets/gp21shopnobg.png"
        alt="gp21shop Logo"
        class="mr-2"
        max-height="50"
        @click="navigateToHome()"
      ></v-img>

      <v-spacer></v-spacer>

      <!-- Mobile Drawer Button -->
      <v-app-bar-nav-icon v-if="isMobile" @click="drawer = !drawer"></v-app-bar-nav-icon>

      <!-- Desktop Navigation -->
      <div v-else class="my-5">
        <router-link
          v-for="(item, index) in menuItems"
          :key="index"
          :to="item.route"
          class="nav-link"
          active-class="active-link"
        >
          <v-btn :style="{ color: siteSettings.header_text_color }" text>
            <v-card-title class="text-h7 py-1">{{ item.title }}</v-card-title>
          </v-btn>
        </router-link>
      </div>
    
    </v-app-bar>

    <v-app-bar
      v-else
      :style="{ backgroundColor: siteSettings.header_color }"
      app
      elevation="12"
      density="prominent"
    >
      <v-img
        src="@/assets/gp21shopnobg.png"
        alt="gp21shop Logo"
        class="mr-2"
        @click="navigateToHome()"
      ></v-img>

      <v-spacer></v-spacer>

      <!-- Mobile Drawer Button -->
      <v-app-bar-nav-icon v-if="isMobile" @click="drawer = !drawer"></v-app-bar-nav-icon>

      <!-- Desktop Navigation -->
      <!-- Desktop Navigation -->
<div v-else class="my-5">
  <template v-for="(item, index) in navItems" :key="index">
    <!-- Tanpa dropdown -->
    <router-link
      v-if="!item.children"
      :to="item.route"
      class="nav-link"
      active-class="active-link"
    >
      <v-btn :style="{ color: siteSettings.header_text_color }" text>
        <v-card-title class="text-h7 py-1">{{ item.title }}</v-card-title>
      </v-btn>
    </router-link>

    <!-- Dengan dropdown (children hasil API) -->
    <v-menu
      v-else
      :open-on-hover="!isMobile"
      transition="fade-transition"
      location="bottom"
      offset="8"
    >
      <template #activator="{ props }">
        <v-btn v-bind="props" text :style="{ color: siteSettings.header_text_color }">
          <v-card-title class="text-h7 py-1">
            {{ item.title }}
            <v-icon size="small" class="ml-1">mdi-chevron-down</v-icon>
          </v-card-title>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(child, ci) in item.children"
          :key="ci"
          @click="$router.push(child.to)"
        >
          <v-list-item-title>{{ child.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </template>
</div>

    </v-app-bar>

    <!-- Mobile Navigation Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      :style="{ backgroundColor: siteSettings.background_color }"
    >
      <v-list>
  <template v-for="(item, index) in navItems" :key="index">
    <v-list-item v-if="!item.children" @click="navigate(item.route)">
      <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item>

    <v-list-group v-else>
      <template #activator="{ props }">
        <v-list-item v-bind="props">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </template>

      <v-list-item
        v-for="(child, ci) in item.children"
        :key="ci"
        @click="$router.push(child.to)"
        class="pl-6"
      >
        <v-list-item-title>{{ child.title }}</v-list-item-title>
      </v-list-item>
    </v-list-group>
  </template>
</v-list>

    </v-navigation-drawer>

    <!-- Main Content Area -->
    <v-main>
      <router-view></router-view>
    </v-main>

    <div v-if="isMobile" class="floating-button-2">
      <v-speed-dial
      location="left bottom"
      transition="fade-transition"
    >
      <template v-slot:activator="{ props: activatorProps }">
        <v-fab
          v-bind="activatorProps"
          size="x-large"
          icon="mdi-whatsapp"
          color="#25D366"
        ></v-fab>
      </template>

      <v-btn
      v-if="contacts && contacts.phone_1"
      prepend-icon="mdi-whatsapp"
      :href="'https://api.whatsapp.com/send/?phone=' + contacts.phone_1 + '&text=&type=phone_number&app_absent=0'"

    >

      <template v-slot:prepend>
        <v-icon color="success"></v-icon>
      </template>

      Admin 1
      </v-btn>
      <v-btn
      v-if="contacts && contacts.phone_2"
      prepend-icon="mdi-whatsapp"
      :href="'https://api.whatsapp.com/send/?phone=' + contacts.phone_2 + '&text=&type=phone_number&app_absent=0'"

    >
      <template v-slot:prepend>
        <v-icon color="success"></v-icon>
      </template>

      Admin 2
      </v-btn>
    </v-speed-dial>
    </div>
    
    <div v-if="!isMobile" class="floating-button">
      <v-speed-dial
      
      location="top right"
      transition="fade-transition"
    >
      <template v-slot:activator="{ props: activatorProps }">
        <v-fab
          v-bind="activatorProps"
          size="x-large"
          icon="mdi-whatsapp"
          color="#25D366"
        ></v-fab>
      </template>

      <v-btn
      v-if="contacts && contacts.phone_1"
      prepend-icon="mdi-whatsapp"
      :href="'https://api.whatsapp.com/send/?phone=' + contacts.phone_1 + '&text=&type=phone_number&app_absent=0'"

    >
      <template v-slot:prepend>
        <v-icon color="success"></v-icon>
      </template>

      Admin 1
      </v-btn>
      <v-btn
      v-if="contacts && contacts.phone_2"

      :href="'https://api.whatsapp.com/send/?phone=' + contacts.phone_2 + '&text=&type=phone_number&app_absent=0'"

      prepend-icon="mdi-whatsapp"
    >
      <template v-slot:prepend>
        <v-icon color="success"></v-icon>
      </template>

      Admin 2
      </v-btn>
    </v-speed-dial>
    </div>

    <!-- Footer -->
    <v-footer :style="{ backgroundColor: siteSettings.footer_color }" dark>
      <v-container>
        <v-row>
          <v-col cols="12" md="4">
            <v-card-title :style="{ color: siteSettings.footer_text_color }">Informasi</v-card-title>
            <v-card-subtitle :style="{ color: siteSettings.footer_text_color }" style="white-space: normal;">
              {{ siteSettings.footer_info }}
            </v-card-subtitle>
          </v-col>

          <!-- <v-col cols="12" md="4">
            <v-card-title :style="{ color: siteSettings.footer_text_color }">Contact Us</v-card-title>
            <v-card-subtitle :style="{ color: siteSettings.footer_text_color }" v-html="siteSettings.footer_contact"></v-card-subtitle>
          </v-col> -->

          <v-col cols="12" md="4">
  <v-card-title :style="{ color: siteSettings.footer_text_color }">Kontak Kami</v-card-title>
  <!-- Social Media Icons -->
  <!-- <div class="mt-2"> -->
      <v-btn
        v-for="(social, index) in filteredSocialMedia"
        :key="index"
        :href="social.socialmedia_url"
        target="_blank"
        :prepend-icon="social.icon"
        class="mx-2"
        variant="text"
        style="color: white;"
      >
        {{ social.username }}
      </v-btn>
    <!-- </div> -->
</v-col>

          <!-- <v-col cols="12" md="4">
            <v-card-title :style="{ color: siteSettings.footer_text_color }">Operational Hours</v-card-title>
            <v-card-subtitle :style="{ color: siteSettings.footer_text_color }" v-html="siteSettings.footer_hours"></v-card-subtitle>
          </v-col> -->
          <v-col cols="12" md="4">
  <v-card-title :style="{ color: siteSettings.footer_text_color }">Jam Operasional</v-card-title>
  <v-card-subtitle 
    :style="{ color: siteSettings.footer_text_color, whiteSpace: 'pre-line' }"
  >
    {{ siteSettings.footer_hours }}
  </v-card-subtitle>
</v-col>

        </v-row>

        <v-divider></v-divider>

        <v-row class="pt-2">
  <v-col class="text-center" cols="12">
    <v-card-subtitle :style="{ color: siteSettings.footer_text_color }">
     © {{ new Date().getFullYear() }} GP21SHOP. All Rights Reserved.
    </v-card-subtitle>

    
  </v-col>
</v-row>


      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "PublicLayout",
  data() {
    return {
      drawer: false,
      siteSettings: {},
      contacts: null,
      socialMedia:[],
      categories:[],
      isMobile: window.innerWidth < 600, // Set initial mobile state
      menuItems: [
        { title: "Home", route: "/" },
        { title: "Tentang Kami", route: "/about" },
        { title: "Grosir", route: "/grosir" },
        { title: "Eceran", route: "/eceran" },
        { title: "Kontak", route: "/contact-us" },
      ],
      // [ADD] hard map judul menu → category_id dari API
categoryIdByTitle: {
  'Grosir': 1,
  'Eceran': 2,
},


    };
  },
  methods: {
// [REPLACE] normalisasi super-lenet
normalizeName(s) {
  return String(s || '')
    // unescape HTML entity
    .replace(/&amp;/gi, '&')
    // samakan full-width ampersand → normal
    .replace(/［|］/g, '')            // just in case brackets sneaked in
    .replace(/＆/g, '&')
    // ganti semua whitespace unicode (NBSP, hair space, dsb.) jadi spasi biasa
    .replace(/[\u00A0\u1680\u180E\u2000-\u200B\u202F\u205F\u3000]/g, ' ')
    // rapikan ampersand agar selalu " x & y "
    .replace(/\s*&\s*/g, ' & ')
    // buang non-alfanumerik kecuali spasi dan &
    .replace(/[^a-zA-Z0-9 &]/g, ' ')
    // kompres spasi
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .trim();
},

// [REPLACE] comparator: exact dulu, kalau gagal, fallback includes
eqCategory(apiName, displayName) {
  const a = this.normalizeName(apiName);
  const b = this.normalizeName(displayName);
  if (a === b) return true;
  // fallback: "hadiah & souvenir" mengandung "souvenir" jika labelmu singkat
  return a.includes(b) || b.includes(a);
},


    navigate(route) {
      this.$router.push(route);
    },
    navigateToHome() {
    this.$router.push("/");
  },
    async fetchSiteSettings() {
      try {
        const response = await this.$axios.get("/site-settings");
        this.siteSettings = response.data.data.reduce((acc, setting) => {
          acc[setting.setting_key] = setting.setting_value;
          return acc;
        }, {});
      } catch (error) {
        console.error("Error fetching site settings:", error);
      }
    },
    handleResize() {
      this.isMobile = window.innerWidth < 600;
    },
  async fetchContact() {
      try {
        const response = await this.$axios.get("/contact");
        this.contacts = response.data.data
        console.log(this.contacts,'DISINI')
      } catch (error) {
        console.error("Error fetching site settings:", error);
      }
    },
    async fetchSocialMedia() {
      try {
        const response =  await this.$axios.get("/social-media");// Adjust the endpoint
        this.socialMedia = response.data.data
      } catch (error) {
        console.error("Error fetching social media:", error);
      }
    },
    async fetchCategoriesNav() {
      try {
        const res = await this.$axios.get("/category");
        this.categories = res.data?.data || [];
      } catch (e) {
        console.error("Error fetching categories for nav:", e);
      }
    },
    slugify(s) {
      return (s || "")
        .toString().normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
        .toLowerCase().replace(/[^a-z0-9\s-]/g, "").trim().replace(/\s+/g, "-");
    },

    // [REPLACE] bangun dropdown: prioritas pakai category_id dari map
buildChildrenFor(title, basePath) {
  const preferredId = this.categoryIdByTitle?.[title];

  let cat = null;

  // 1) Cari by ID (kalau ada di map)
  if (preferredId != null) {
    cat = this.categories.find(c => Number(c.category_id) === Number(preferredId));
  }

  // 2) Fallback: kalau belum ketemu (atau map tak ada), cocokkan nama (lenient)
  if (!cat) {
    const byName = (s) => String(s || '').toLowerCase().replace(/&amp;/g,'&').trim();
    const want  = byName(title);
    cat = this.categories.find(c => {
      const got = byName(c.category);
      return got === want || got.includes(want) || want.includes(got);
    });
  }

  if (!cat) {
    // optional 1x log untuk debugging
    if (!this._loggedCatOnce) {
      this._loggedCatOnce = true;
      console.warn('[NAV] Category not found for:', title, 
        'Available:', (this.categories || []).map(c => `${c.category_id}:${c.category}`));
    }
    return null;
  }

  // Build children dari subcategories
  const children = [{ title: `Semua ${title}`, to: { path: basePath } }];

  const subs = Array.isArray(cat.subcategories) ? [...cat.subcategories] : [];

// urutkan A-Z
subs.sort((a, b) => 
  String(a.subcategory).localeCompare(String(b.subcategory), 'id', { sensitivity: 'base' })
);

for (const sc of subs) {
  const subSlug = sc.slug || this.slugify(sc.subcategory);
  children.push({
    title: sc.subcategory,
    to: { path: basePath, query: { sub: subSlug, sid: sc.subcategory_id } }
  });
}
  return children;
},


  },
  async mounted() {
    this.fetchSiteSettings();
    this.fetchContact();
    this.fetchSocialMedia();
    await this.fetchCategoriesNav();     // ⬅️ ambil kategori+sub
    window.addEventListener("resize", this.handleResize);
  },
  computed: {
  filteredSocialMedia() {
    return this.socialMedia.filter(socmed => socmed.socialmedia_url && socmed.username);
  },
  navItems() {
  return this.menuItems.map(mi => {
    if (mi.title === "Grosir") {
      const children = this.buildChildrenFor("Grosir", "/grosir");
      return children?.length ? { ...mi, children } : mi;
    }
    if (mi.title === "Eceran") {           // <- pakai label menu ini
      const children = this.buildChildrenFor("Eceran", "/eceran");
      return children?.length ? { ...mi, children } : mi;
    }
    return mi;
  });
},

},
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
  .floating-button {
  position: fixed; /* Ensures it stays in place while scrolling */
  bottom: 40px;    /* Adjust the distance from the bottom of the screen */
  right: 100px;     /* Adjust the distance from the right edge */
  z-index: 1000;   /* Makes sure it stays above other content */
}

.floating-button-2 {
  position: fixed; /* Ensures it stays in place while scrolling */
  bottom: 60px;    /* Adjust the distance from the bottom of the screen */
  right: 100px;     /* Adjust the distance from the right edge */
  z-index: 1000;   /* Makes sure it stays above other content */
}

.nav-link {
  text-decoration: none;
}
.nav-link.active-link {
  color: #7DC4B2;
}
.v-app-bar {
  box-shadow: none;
}
.v-footer {
  padding-top: 1rem;
  padding-bottom: 1rem;
}


</style>

